// Import necessary dependencies
import axios from 'axios';


const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || 8080,
  timeout: 5000,
});

// Add interceptor for request
instance.interceptors.request.use(
  (config) => {
    // Add any headers or configurations as needed
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add interceptor for response
instance.interceptors.response.use(
  (response) => {
    // Handle successful response
    const { data } = response;

    if (data && data.token) {
      // Assuming your API response contains a token field
      localStorage.setItem('token', data.token);

      const roles = data.user.role;

      localStorage.setItem('role', roles);


    }
    return response;
  },
  (error) => {
    // Handle error response
    return Promise.reject(error);
  }
);

export default instance;
